import { render, staticRenderFns } from "./BankStatementDetails.vue?vue&type=template&id=5675a4f3&scoped=true&"
import script from "./BankStatementDetails.vue?vue&type=script&lang=ts&"
export * from "./BankStatementDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BankStatementDetails.vue?vue&type=style&index=0&id=5675a4f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675a4f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VCol,VCombobox,VDivider,VIcon,VRow,VTooltip})
